// CANONICAL COPY (GH #7115). src/constants/obligations/obl-cra-coordinated-vulnerability-disclosure.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-cra-coordinated-vulnerability-disclosure',
  title: 'Operate a coordinated vulnerability disclosure policy with a single point of contact',
  description:
    "Confirm that the manufacturer has a policy on coordinated vulnerability disclosure (CRA Art. 13(12) and Annex I, Part II §5) and operates a single point of contact for the reporting of potential vulnerabilities in its products with digital elements (Art. 13(17), 13(20)). The policy describes how external researchers and users can report vulnerabilities, the manufacturer's triage and acknowledgement commitments, the safe-harbour expectations, and the disclosure timeline. The contact address is publicly accessible. Measures are taken to facilitate the sharing of information about potential vulnerabilities, including with maintainers of integrated third-party components (Annex I, Part II §6). Review the CVD policy, the intake mailbox or platform, and the response-time record.",
  category: 'incidents',
  scfIds: ['SCF-PPL-008', 'SCF-GOV-005'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Coordinated vulnerability disclosure policy is published',
    },
    { type: 'document-approved', description: 'Policy has been approved' },
    { type: 'document-within-sla', description: 'Policy review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
